import { writable, derived, readable } from 'svelte/store';
import moment from "moment";


function formaToFixed(value) {
  return parseFloat(value.toFixed(2));
}

export const startDate = writable(moment().startOf("year"))
export const endDate = writable(moment().endOf("year"))
export const ral = writable(0);

export const numeroMensilita = writable(12)


export const numeroGiorni = derived(
  [startDate, endDate],
  ([$startDate, $endDate]) => {
    return Math.floor(($startDate.toDate().getTime() - $endDate.toDate().getTime()) / 86400000) * -1
  }
)

export const coniugi = writable({
  numero: 0,
  mesi: 12,
  perc: 0,
});
export const figliSopra = writable({
  numero: 0,
  mesi: 12,
  perc: 50,
});
export const altriFamiliari = writable({
  numero: 0,
  mesi: 12,
  perc: 50,
});


export const isTempoIndeterminato = writable(true);

// questa mi serve solo per i cambi di tipo agevolazione
// export const aliquotaIVSTemp = writable(23.81)

// export const aliquotaAltreAss = writable(3.5)
// questa mi serve solo per i cambi di tipo agevolazione
// export const aliquotaAltreAssTemp = writable(3.5)

// ALIQUOTE INPS DIPENDENTE
export const aliquotaIVS = writable(23.81)
export const aliquotaIntegrazioneLavoratore = writable(0)
export const aliquotaIntegrazione = writable(0)
export const aliquotaNaspi = writable(1.31)
export const aliquotaContrMalattia = writable(2.44)
export const aliquotaContrMaternita = writable(0.24)
export const aliquotaCUAF = writable(0.68)
export const aliquotaFondoGaranziaTfr = writable(0.20)
export const aliquotaIVSDipendente = writable(9.19)
export const aliquotaFormazione = writable(0.30)
export const aliquotaInail = writable(0.4)

export const totaleAliquotaInps = derived(
  [
    aliquotaIVS,
    aliquotaIntegrazioneLavoratore,
    aliquotaIntegrazione,
    aliquotaNaspi,
    aliquotaContrMalattia,
    aliquotaContrMaternita,
    aliquotaCUAF,
    aliquotaFondoGaranziaTfr,
    aliquotaIVSDipendente,
    aliquotaFormazione,
  ],
  ([
    $aliquotaIVS,
    $aliquotaIntegrazioneLavoratore,
    $aliquotaIntegrazione,
    $aliquotaNaspi,
    $aliquotaContrMalattia,
    $aliquotaContrMaternita,
    $aliquotaCUAF,
    $aliquotaFondoGaranziaTfr,
    $aliquotaIVSDipendente,
    $aliquotaFormazione,
  ]) => {
    return $aliquotaIVS + $aliquotaIntegrazioneLavoratore + $aliquotaIntegrazione + $aliquotaNaspi + $aliquotaContrMalattia + $aliquotaContrMaternita + $aliquotaCUAF + $aliquotaFondoGaranziaTfr + $aliquotaIVSDipendente + $aliquotaFormazione 
  }
)




export const totaleInps = derived(
  [totaleAliquotaInps, ral],
  ([$totaleAliquotaInps, $ral]) => {
    return ($totaleAliquotaInps / 100) * $ral
  }
)


// para subordinato
export const aliquotaIvsParasub = writable(0)
export const aliquotaMalattiaMaternitaAnfParasub = writable(0)
export const aliquotaDisCollParasub = writable(0)
export const aliquotaInailParasub = writable(0)


export const totaleAliquotaInpsParasub = derived(
  [ aliquotaIvsParasub, aliquotaMalattiaMaternitaAnfParasub, aliquotaDisCollParasub ],
  ([$aliquotaIvsParasub, $aliquotaMalattiaMaternitaAnfParasub, $aliquotaDisCollParasub]) => {
    return $aliquotaIvsParasub + $aliquotaMalattiaMaternitaAnfParasub + $aliquotaDisCollParasub 
  }
)


export const totaleInpsParasub = derived(
  [
    totaleAliquotaInpsParasub,
    ral
  ],
  ([$totaleAliquotaInpsParasub, $ral]) => (($totaleAliquotaInpsParasub / 100) * $ral)
)

export const totaleInpsParasubComm = derived([totaleInpsParasub],
  ([$totaleInpsParasub]) => {
    return $totaleInpsParasub * 2 / 3
  })

export const totaleInpsParasubLav = derived([totaleInpsParasub],
  ([$totaleInpsParasub]) => {
    return $totaleInpsParasub * 1 / 3
  })

// export const aliquotaIvsmalMatComm = writable(23.25)
// export const aliquotaIvsCollaboratore = writable(11.678)

export const irpefRegionale = writable(0)
export const irpefComunale = writable(0.0)

export const isCococo = writable(false)
export const altreDetrazioniEventuali = writable(0)

export const esonero080 = writable(0)
// export const esonero080 = writable(0.8) 


export const importoIVSDatore = derived(
  [
    aliquotaIVS,
    ral
  ],
  ([$aliquotaIVS, $ral]) => formaToFixed(($aliquotaIVS / 100) * $ral)
)


export const importoIvsParasubCommittente = derived(
  [
    aliquotaIvsParasub,
    ral
  ],
  ([$aliquotaIvsParasub, $ral]) => formaToFixed((($aliquotaIvsParasub / 100) * $ral) * 2 / 3)
)

export const importoIvsParasubLavoratore = derived(
  [
    aliquotaIvsParasub,
    ral
  ],
  ([$aliquotaIvsParasub, $ral]) => formaToFixed((($aliquotaIvsParasub / 100) * $ral) * 1 / 3)
)

export const importoMalattiaMaternitaAnfParasubComm = derived(
  [
    aliquotaMalattiaMaternitaAnfParasub,
    ral
  ],
  ([$aliquotaMalattiaMaternitaAnfParasub, $ral]) => formaToFixed((($aliquotaMalattiaMaternitaAnfParasub / 100) * $ral) * 2 / 3)
)

export const importoMalattiaMaternitaAnfParasubLav = derived(
  [
    aliquotaMalattiaMaternitaAnfParasub,
    ral
  ],
  ([$aliquotaMalattiaMaternitaAnfParasub, $ral]) => formaToFixed((($aliquotaMalattiaMaternitaAnfParasub / 100) * $ral) * 1 / 3)
)

export const importoDisCollParasubComm = derived(
  [
    aliquotaDisCollParasub,
    ral
  ],
  ([$aliquotaDisCollParasub, $ral]) => formaToFixed((($aliquotaDisCollParasub / 100) * $ral) * 2 / 3)
)

export const importoDisCollParasubLav = derived(
  [
    aliquotaDisCollParasub,
    ral
  ],
  ([$aliquotaDisCollParasub, $ral]) => formaToFixed((($aliquotaDisCollParasub / 100) * $ral) * 1 / 3)
)


export const importoInailParasubComm = derived(
  [
    aliquotaInailParasub,
    ral
  ],
  ([$aliquotaInailParasub, $ral]) => formaToFixed((($aliquotaInailParasub / 100) * $ral) * 2 / 3)
)

export const importoInailParasubLav = derived(
  [
    aliquotaInailParasub,
    ral
  ],
  ([$aliquotaInailParasub, $ral]) => formaToFixed((($aliquotaInailParasub / 100) * $ral) * 1 / 3)
)


export const importoInailParasubTot = derived(
  [
    importoInailParasubLav,
    importoInailParasubComm
  ],
  ([$importoInailParasubLav, $importoInailParasubComm]) => formaToFixed($importoInailParasubLav + $importoInailParasubComm)
)



export const importoIntegrazione = derived(
  [aliquotaIntegrazione, ral],
  ([$aliquotaIntegrazione, $ral]) => formaToFixed(($aliquotaIntegrazione / 100) * $ral)
)
export const importoIntegrazioneLavoratore = derived(
  [aliquotaIntegrazioneLavoratore, ral],
  ([$aliquotaIntegrazioneLavoratore, $ral]) => formaToFixed(($aliquotaIntegrazioneLavoratore / 100) * $ral)
)

export const importoNaspi = derived(
  [aliquotaNaspi, ral],
  ([$aliquotaNaspi, $ral]) => formaToFixed($ral * ($aliquotaNaspi / 100))
)

export const contributoMalattia = derived(
  [aliquotaContrMalattia, ral],
  ([$aliquotaContrMalattia, $ral]) => formaToFixed($ral * ($aliquotaContrMalattia / 100))
)

export const importoContrMaternita = derived(
  [aliquotaContrMaternita, ral],
  ([$aliquotaContrMaternita, $ral]) => formaToFixed($ral * ($aliquotaContrMaternita / 100))
)

export const importoCUAF = derived(
  [aliquotaCUAF, ral],
  ([$aliquotaCUAF, $ral]) => formaToFixed($ral * ($aliquotaCUAF / 100))
)

export const importoFondoGaranziaTfr = derived(
  [aliquotaFondoGaranziaTfr, ral],
  ([$aliquotaFondoGaranziaTfr, $ral]) => formaToFixed($ral * ($aliquotaFondoGaranziaTfr / 100))
)

export const importoFormazione = derived(
  [aliquotaFormazione, ral],
  ([$aliquotaFormazione, $ral]) => formaToFixed($ral * ($aliquotaFormazione / 100))
)




// export const importoAltreAss = derived(
//   [
//     aliquotaAltreAss,
//     ral
//   ],
//   ([$aliquotaAltreAss, $ral]) => ($aliquotaAltreAss / 100) * $ral
// )


export const importoInail = derived(
  [
    aliquotaInail,
    ral,
    isCococo
  ],
  ([$aliquotaInail, $ral, $isCococo]) => {
    if ($isCococo) {
      return (($aliquotaInail / 100) * $ral) * (2 / 3)
    }
    return ($aliquotaInail / 100) * $ral
  }
)

export const importoInailCollaboratore = derived(
  [
    aliquotaInail,
    ral,
    isCococo
  ],
  ([$aliquotaInail, $ral, $isCococo]) => {
    if ($isCococo) {
      return (($aliquotaInail / 100) * $ral) * (1 / 3)
    }
    return 0
  }
)

export const importoIVSDipendente = derived(
  [
    aliquotaIVSDipendente,
    ral,
    isCococo
  ],
  ([ $aliquotaIVSDipendente, $ral, $isCococo]) => {
    if ($isCococo) {
      return 0
      } else {
        return formaToFixed(($aliquotaIVSDipendente / 100) * $ral)
      }    
})


export const importoEsonero080 = derived(
  [ral, esonero080], ( [$ral, $esonero080]) => {
    // if ($ral <= 35000) {
    //   return $ral * ($esonero080 / 100)
    // }
    return 0
  })

export const totaleInpsLavoratoreDip = derived(
  [importoIVSDipendente, importoIntegrazioneLavoratore],
  ([$importoIVSDipendente, $importoIntegrazioneLavoratore]) => {
    return $importoIVSDipendente + $importoIntegrazioneLavoratore
  }
)

export const totaleInpsDatoreDip = derived(
  [
    importoNaspi, importoCUAF,
    contributoMalattia, importoContrMaternita,
    importoFondoGaranziaTfr, importoFormazione,
    importoIVSDatore, importoIntegrazione
  ],
  ([$importoNaspi, $importoCUAF, $contributoMalattia, $importoContrMaternita, $importoFondoGaranziaTfr, $importoFormazione, $importoIVSDatore, $importoIntegrazione]) => {
    return $importoNaspi + $importoCUAF + $contributoMalattia + $importoContrMaternita + $importoFondoGaranziaTfr + $importoFormazione + $importoIVSDatore + $importoIntegrazione
  }
)

export const imponibileIRPEF = derived(
  [ral, totaleInpsLavoratoreDip, totaleInpsParasubLav, importoInailParasubLav, importoEsonero080],
  ([$ral, $totaleInpsLavoratoreDip, $totaleInpsParasubLav, $importoInailParasubLav ,$importoEsonero080]) => (
    $ral - $totaleInpsLavoratoreDip - $totaleInpsParasubLav - $importoInailParasubLav + $importoEsonero080
  )
)





export const irpefLorda = derived(
  [imponibileIRPEF],
  ([$imponibileIRPEF]) => {
      if ($imponibileIRPEF <= 28000) {
        return $imponibileIRPEF * 0.23;
      }
      if ($imponibileIRPEF > 28000 && $imponibileIRPEF <= 50000) {
        return 6440 + ($imponibileIRPEF - 28000) * 0.35;
      }
      // if ($imponibileIRPEF > 28000 && $imponibileIRPEF <= 50000) {
      //   return 6700 + ($imponibileIRPEF - 28000) * 0.35;
      // }
      if ($imponibileIRPEF > 50000) {
        return 14140 + ($imponibileIRPEF - 50000) * 0.43;
      }
      return 0;
    
  }
)


export const sommac4l206 = derived(
  [imponibileIRPEF, numeroGiorni],
  ([$imponibileIRPEF, $numeroGiorni]) => {
    // se impobibile va da 0 a 8500 return il 7,10% dell'imponibile
    if ($imponibileIRPEF >= 0 && $imponibileIRPEF <= 8500) {
      return (($imponibileIRPEF * 0.071) / 365) * $numeroGiorni;
    }

    if ($imponibileIRPEF > 8500 && $imponibileIRPEF <= 15000) {
      return (($imponibileIRPEF * 0.053) / 365) * $numeroGiorni;
    }

    if ($imponibileIRPEF > 15000 && $imponibileIRPEF <= 20000) {
      return (($imponibileIRPEF * 0.048) / 365) * $numeroGiorni;
    }
    // For values above 8500
    return 0;
  }
)

export const ulterioreDetrazioneC6 = derived(
  [imponibileIRPEF, numeroGiorni],
  ([$imponibileIRPEF, $numeroGiorni]) => {
    if ($imponibileIRPEF > 20000 && $imponibileIRPEF <= 32000) {
      return ((1000) / 365) * $numeroGiorni;
    }

    if ($imponibileIRPEF > 32000 && $imponibileIRPEF <= 40000) {
      return (((1000 * ((40000 - $imponibileIRPEF) / 8000))) / 365) * $numeroGiorni;
    }

    // For values above 8500
    return 0;
  }
)

export const detrazioneAggiuntiva65euro = derived(
  [imponibileIRPEF, numeroGiorni],
  ([$imponibileIRPEF, $numeroGiorni]) => {
    if ($imponibileIRPEF >= 25000 && $imponibileIRPEF <= 35000) {
      return (65 / 365) * $numeroGiorni;
    }

    return 0
  })


export const detrazioniPerRedditiLavoro = derived(
  [imponibileIRPEF, isTempoIndeterminato, numeroGiorni, detrazioneAggiuntiva65euro],
  ([$imponibileIRPEF, $isTempoIndeterminato, $numeroGiorni, $detrazioneAggiuntiva65euro]) => {
    if ($imponibileIRPEF <= 15000) {
      var valore = (1955 / 365) * $numeroGiorni;
      if ($isTempoIndeterminato) {
        if (valore < 690) {
          return 690
        } else {
          return valore
        }
      } else {
        if (valore < 1380) {
          return 1380
        } else {
          return valore
        }
      }

    }
      if ($imponibileIRPEF > 15000 && $imponibileIRPEF <= 28000) {
        return (((1910 + (1190 * ((28000 - $imponibileIRPEF) / 13000))) / 365) * $numeroGiorni) + $detrazioneAggiuntiva65euro;
      }
      if ($imponibileIRPEF > 28000 && $imponibileIRPEF <= 50000) {
        return (((1910 * ((50000 - $imponibileIRPEF) / 22000)) / 365) * $numeroGiorni) + $detrazioneAggiuntiva65euro;
      }
      if ($imponibileIRPEF > 50000) {
        return 0
      }
      return 0;
  })


  


export const detrazioniConiugi = derived(
  [imponibileIRPEF, isTempoIndeterminato, coniugi],
  ([$imponibileIRPEF, $isTempoIndeterminato, $coniugi]) => {
    if ($coniugi.numero != 1) {
      return 0
    }
    if ($imponibileIRPEF <= 15000) {
      return (800 - (110 * ($imponibileIRPEF / 15000))) / 12 * $coniugi.mesi
    }
    if ($imponibileIRPEF > 15000 && $imponibileIRPEF <= 40000) {
      let importo = 690
      if ($imponibileIRPEF > 29000 && $imponibileIRPEF <= 29200) {
        // return 700 / 12 * $coniugi.mesi
        importo += 10
      }
      if ($imponibileIRPEF > 29200 && $imponibileIRPEF <= 34700) {
        // return 710 / 12 * $coniugi.mesi
        importo += 20
      }
      if ($imponibileIRPEF > 34700 && $imponibileIRPEF <= 35000) {
        // return 720 / 12 * $coniugi.mesi
        importo += 30
      }
      if ($imponibileIRPEF > 35000 && $imponibileIRPEF <= 35100) {
        importo += 20
      }
      if ($imponibileIRPEF > 35100 && $imponibileIRPEF <= 35200) {
        importo += 10
        // return 700 / 12 * $coniugi.mesi
      }
      // caso di default
      return importo / 12 * $coniugi.mesi
    }
    if ($imponibileIRPEF > 40000 && $imponibileIRPEF <= 80000) {
      return (690 * ( (80000 - $imponibileIRPEF) / 40000)) / 12 * $coniugi.mesi
    }
    if ($imponibileIRPEF > 80000) {
      return 0
    }
    return 0;
  })


export const trattamentoIntegrativo = derived(
    [imponibileIRPEF, detrazioniPerRedditiLavoro, irpefLorda, numeroGiorni, altreDetrazioniEventuali],
    ([$imponibileIRPEF, $detrazioniPerRedditiLavoro, $irpefLorda, $numeroGiorni, $altreDetrazioniEventuali]) => {
      if ($imponibileIRPEF <= 15000 && $detrazioniPerRedditiLavoro < $irpefLorda) {
        return (1200 / 365) * $numeroGiorni
      }

      if ($imponibileIRPEF > 15000 && $imponibileIRPEF <= 28000 && ($detrazioniPerRedditiLavoro + $altreDetrazioniEventuali) > $irpefLorda) {
        return (1200 / 365) * $numeroGiorni
      }
    }
  )

export const detrazioniFigliSopra21 = derived(
  [imponibileIRPEF, figliSopra],
  ([$imponibileIRPEF, $figliSopra]) => {
    if ($figliSopra.numero == 0 || $imponibileIRPEF == 0) {
      return 0
    }
    
    var valoreFiglio = 15000
    var valoreTotale = 80000 * (valoreFiglio * $figliSopra.numero) 

    
    if ($imponibileIRPEF <= valoreTotale ) {
      var importoDetrazione = ((950 * (valoreTotale - $imponibileIRPEF) / valoreTotale) * ($figliSopra.perc / 100)) / 12 * $figliSopra.mesi

      if ($figliSopra.numero >= 4) {
        importoDetrazione = importoDetrazione + (1200 * ($figliSopra.perc / 100) / 12 * $figliSopra.mesi)
      }
      return importoDetrazione
    }

    return 0;
  })



export const detrazioniAltriFamiliari = derived(
  [imponibileIRPEF, altriFamiliari],
  ([$imponibileIRPEF, $altriFamiliari]) => {
    if ($altriFamiliari.numero == 0 || $imponibileIRPEF == 0) {
      return 0
    }
    
    var valoreTotale = 80000

    
    if ($imponibileIRPEF <= valoreTotale ) {
      return ((750 * (valoreTotale - $imponibileIRPEF) / valoreTotale) * ($altriFamiliari.perc / 100)) / 12 * $altriFamiliari.mesi
    }

    return 0;
  })

  export const irpefNetta = derived([
    irpefLorda,
    detrazioniPerRedditiLavoro,
    detrazioniAltriFamiliari,
    detrazioniConiugi,
    detrazioniFigliSopra21,
    ulterioreDetrazioneC6
  ], 
    ([$irpefLorda, $detrazioniPerRedditiLavoro, $detrazioniAltriFamiliari, $detrazioniConiugi, $detrazioniFigliSopra21, $ulterioreDetrazioneC6]) => {
      const val = $irpefLorda - $detrazioniPerRedditiLavoro - $detrazioniAltriFamiliari - $detrazioniConiugi - $detrazioniFigliSopra21 - $ulterioreDetrazioneC6 ;
    if (val < 0) {
      return 0
    }
    return val
  })
  

export const importoIrpefComunale = derived(
  [imponibileIRPEF, irpefComunale], 
  ([$imponibileIRPEF ,$irpefComunale]) => $imponibileIRPEF * ($irpefComunale / 100)
  )



// tfr annuale
export const rateoTfrAnnuale = derived(
  [
    ral, isCococo
  ],
  ([ $ral, $isCococo]) =>{ 
    if ($isCococo) {
      return 0
    }
    return formaToFixed($ral / 13.5)
  }
)



// contributi dovuti annuali
export const contibutiAnno = derived(
  [totaleInps, totaleInpsParasub, importoInail, importoInailParasubTot,ral],
  ([$totaleInps,
    $totaleInpsParasub,
    $importoInail, $importoInailParasubTot,
    $ral]) => {
      var dovuto = $totaleInps + $totaleInpsParasub + $importoInail + $importoInailParasubTot 

      if ($ral <= 35000) {
        dovuto = dovuto
      }
      return dovuto
    })

// imposte annuali
export const imposteAnnuali = derived(
  [irpefNetta, irpefRegionale, importoIrpefComunale],
  ([$irpefNetta, $irpefRegionale, $importoIrpefComunale]) => {
    var importo = $irpefNetta + $irpefRegionale + $importoIrpefComunale
    return importo > 0 ? importo : 0
  }
)


// costo annuale
export const costoAnnuale = derived(
  [ral, totaleInpsDatoreDip, totaleInpsParasubComm, importoInailParasubComm, importoInail, rateoTfrAnnuale],
  ([$ral, $totaleInpsDatoreDip, $totaleInpsParasubComm, $importoInailParasubComm, $importoInail, $rateoTfrAnnuale]) => {
      return $ral + $totaleInpsDatoreDip + $totaleInpsParasubComm + $importoInailParasubComm + $importoInail + $rateoTfrAnnuale
    }
)

// netto dipendente annuale
export const nettoDipendente = derived(
  [costoAnnuale, imposteAnnuali, contibutiAnno, rateoTfrAnnuale, sommac4l206, trattamentoIntegrativo],
  ([$costoAnnuale, $imposteAnnuali, $contibutiAnno, $rateoTfrAnnuale, $sommac4l206, $trattamentoIntegrativo]) => {
    
    const safeValue = (value) => (value === undefined || value === null || Number.isNaN(value)) ? 0 : value;

    return safeValue($costoAnnuale) - safeValue($imposteAnnuali) - safeValue($contibutiAnno) - safeValue($rateoTfrAnnuale) + safeValue($sommac4l206) + safeValue($trattamentoIntegrativo);
  }
);

// tfr mensile
export const rateoTfrMensile = derived(
  [
    rateoTfrAnnuale, numeroMensilita
  ],
  ([ $rateoTfrAnnuale, $numeroMensilita]) => $rateoTfrAnnuale / $numeroMensilita
)


// contributi dovuti mensile
export const contibutMese = derived(
  [contibutiAnno, numeroMensilita],
  ([$contributiAnno,
    $numeroMensilita]) => $contributiAnno / $numeroMensilita
  )

// imposte mensili
export const imposteMensili = derived(
  [imposteAnnuali, numeroMensilita],
  ([$imposteAnnuali, $numeroMensilita]) => $imposteAnnuali / $numeroMensilita
)

// netto dipendente mensile
export const nettoDipendenteMensile = derived(
  [nettoDipendente, numeroMensilita],
  ([$nettoDipendente, $numeroMensilita]) => $nettoDipendente / $numeroMensilita
)
// costo mensile
export const costoMensile = derived(
  [costoAnnuale, numeroMensilita],
  ([$costoAnnuale, $numeroMensilita]) => $costoAnnuale / $numeroMensilita
)

